import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Avatar,
  Box,
  CircularProgress,
} from "@mui/material";
import { createVehicle } from "../../services/vehicleService";
import { getPlacesByUserNameParam } from "../../services/userService";
import SuccessMessageModal from "../Reusable/SuccessMessageModal";
import WarningMessageModal from "../Reusable/WarningMessageModal";

const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

const CreateVehiculoModal = ({ isOpen, onClose }) => {
  const [vehicleData, setVehicleData] = useState({
    plate: "",
    model: "",
    charger_type: "",
    photo: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [userName, setUserName] = useState("");

  useEffect(() => {
    if (isOpen) {
      const name = sessionStorage.getItem("username");
      setUserName(name);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVehicleData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhotoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
      setVehicleData(prev => ({...prev, photo: URL.createObjectURL(e.target.files[0])}));
    }
  };

  const handleSave = async () => {
    if (!vehicleData.plate) {
      setModalMessage("La placa es obligatoria.");
      setIsWarningOpen(true);
      return;
    }

    setIsLoading(true);
    let photoBase64 = "";
    if (selectedFile) {
        photoBase64 = await toBase64(selectedFile);
    }

    try {
      const placeId = sessionStorage.getItem("selectedPlaceId");
      const userName = sessionStorage.getItem("username");
      const userDetailsResponse = await getPlacesByUserNameParam(userName);
      const userData = userDetailsResponse.data[0];

      if (!userData || !userData.id || !placeId) {
        setModalMessage("No se pudo obtener la información del usuario o la sede.");
        setIsWarningOpen(true);
        setIsLoading(false);
        return;
      }

      const dataToSubmit = {
          ...vehicleData,
          photo: photoBase64,
          user_id: userData.id,
          place_id: parseInt(placeId, 10),
      };

      await createVehicle(dataToSubmit);
      setModalMessage("Vehículo creado exitosamente.");
      setIsSuccessOpen(true);
    } catch (error) {
      const errorMessage = error.response?.data?.detail || "Error al crear el vehículo.";
      setModalMessage(errorMessage);
      setIsWarningOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setIsSuccessOpen(false);
    onClose(true);
  };

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)}>
      <DialogTitle>Registrar Nuevo Vehículo para {userName}</DialogTitle>
      <DialogContent>
        {isLoading ? <Box display="flex" justifyContent="center"><CircularProgress /></Box> : (
            <>
                <TextField margin="dense" label="Placa *" name="plate" fullWidth value={vehicleData.plate} onChange={handleChange} />
                <TextField margin="dense" label="Modelo" name="model" fullWidth value={vehicleData.model} onChange={handleChange} />
                <FormControl fullWidth margin="dense">
                    <InputLabel>Tipo de Cargador</InputLabel>
                    <Select name="charger_type" value={vehicleData.charger_type} onChange={handleChange} label="Tipo de Cargador">
                        <MenuItem value="Tipo 1">Tipo 1</MenuItem>
                        <MenuItem value="Tipo 2">Tipo 2</MenuItem>
                    </Select>
                </FormControl>
                <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Button variant="contained" component="label">
                        Subir Foto
                        <input type="file" hidden accept="image/*" onChange={handlePhotoChange} />
                    </Button>
                    {vehicleData.photo && <Avatar src={vehicleData.photo} sx={{ width: 100, height: 100, mt: 2 }} />}
                </Box>
            </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)}>Cancelar</Button>
        <Button onClick={handleSave} color="primary" disabled={isLoading}>Guardar</Button>
      </DialogActions>
      <SuccessMessageModal isOpen={isSuccessOpen} message={modalMessage} onClose={handleSuccessClose} />
      <WarningMessageModal isOpen={isWarningOpen} message={modalMessage} onClose={() => setIsWarningOpen(false)} />
    </Dialog>
  );
};

export default CreateVehiculoModal;
